
export enum CustomerMatchRequestTypeCd {
	DETAILED = 'Detailed',
	PARTIAL_DETAILED = 'PartialDetailed',
	SIMPLE = 'Simple'}
